import React, { useState } from 'react';
import { createDepositSession } from '../../services/paymentService';

interface DepositModalProps {
  onClose: () => void;
}

export default function DepositModal({ onClose }: DepositModalProps) {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDeposit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const usdAmount = parseFloat(amount);
    if (!usdAmount || usdAmount <= 0) {
      setError('Please enter a valid amount.');
      return;
    }
    setLoading(true);
    try {
      const session = await createDepositSession(usdAmount);
      // Redirect to Stripe Checkout URL returned by the backend
      if (session.url) {
        window.location.href = session.url;
      }
      onClose();
    } catch (err: any) {
      setError(err.message || 'Payment failed - please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Deposit">
      <div className="modal-box">
        <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        <h2 className="modal-title">💵 Deposit Funds</h2>

        {error && <div className="modal-error">{error}</div>}

        <form onSubmit={handleDeposit} className="auth-form">
          <label className="auth-label">
            Amount (USD)
            <input
              type="number"
              className="auth-input"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              min="1"
              step="0.01"
              placeholder="100.00"
              required
            />
          </label>
          <p className="deposit-note">
            You will be redirected to a secure Stripe checkout to complete your deposit.
          </p>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Redirecting to Checkout…' : 'Deposit'}
          </button>
        </form>
      </div>
    </div>
  );
}
